<template>
  <div id="app">
    <div v-if="!IsMobile">
      <fy-head></fy-head>
    </div>
    <div v-if="IsMobile">
      <fyHeadMobile :isShowMenu="headMobileVisible"></fyHeadMobile>
      <div class="content">
        <div class="fy-head">
          <router-link to="/"><img :src="logo" class="head-logo"></router-link>
          <div class="fy-head-menu" :class="{'fy-head-menu-close':headMobileVisible}" @click="showDrawer">
            <span class="fy-head-menu-item fy-head-menu-item-top">
              <span class="fy-head-menu-crust fy-head-menu-crust-top"></span>
            </span>
            <span class="fy-head-menu-item fy-head-menu-item-bottom">
              <span class="fy-head-menu-crust fy-head-menu-crust-bottom"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <router-view />
    <div class="footer" v-if="!IsMobile">
      <div class="record-number">
        <a style="margin-left:42px" href="https://beian.miit.gov.cn/?spm=a2c4g.11186623.J_9220772140.115.26b47b3dHmt3yq#/Integrated/index">备案号 浙ICP备2020039278号-1</a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=5176.19720258.J_9220772140.117.47cb2c4atLhNCE">
          <img :src="recordNo" style="float:left;" />
          <p style="float:left;margin-left:10px;line-height:20px">浙公网安备 33010302003666号</p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { IsMobile } from "./utils";
import fyHead from "./components/tpl/top-head/top-head.vue";
import fyHeadMobile from "./components/tpl/top-head-mobile/top-head-mobile.vue";
import logo from "@/assets/logo.png";
import recordNo from "@/assets/beianhao.png";
export default Vue.extend({
  name: "fy",
  components: {
    fyHead,
    fyHeadMobile,
  },
  data() {
    return {
      IsMobile,
      logo,
      recordNo,
      headMobileVisible: false,
    };
  },
  created() {
    IsMobile && this.getHomeConfig();
  },
  mounted() {},
  watch: {
    $route() {
      this.headMobileVisible = false;
      document.body.classList.remove("fixed");
    },
  },
  methods: {
    showDrawer() {
      if (this.headMobileVisible) {
        document.body.classList.remove("fixed");
      } else {
        document.body.classList.add("fixed");
      }
      this.headMobileVisible = !this.headMobileVisible;
    },
    getHomeConfig() {
      this.$https
        .get("/api/homeConfig/getConfigByType", {
          params: {
            type: 1,
          },
        })
        .then((res) => {
          const img = res.data;
          img?.id && (this.logo = img.imgPath);
        });
    },
  },
});
</script>
<style lang="scss" scoped>
.head {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  margin-bottom: 15px;
}
.footer {
  width: 100%;
  // position: fixed;
  bottom: 0;
  left: -15px;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  .record-number {
    text-align: center;
    font-size: 12px;
    a {
      display: block;
      color: #9b9b9b;
      img{
        width: 20px;
        display: inline-block;
        height: 20px;
        margin-right: 12px;
      }
    }
  }
}
</style>